import { render, staticRenderFns } from "./Acl.vue?vue&type=template&id=6f119f18&scoped=true"
import script from "./Acl.vue?vue&type=script&lang=ts"
export * from "./Acl.vue?vue&type=script&lang=ts"
import style0 from "./Acl.vue?vue&type=style&index=0&id=6f119f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f119f18",
  null
  
)

export default component.exports